
import React from 'react';

import AnalyzeDefunctParPageState from './AnalyzeDefunctParPage.state';

const AnalyzeDefunctParPage = (props) => {

    return (
        <AnalyzeDefunctParPageState
            match={props.match}
        />
    )
}

export default AnalyzeDefunctParPage;
